/**
 * 生成基于随机数的 UUID
 * @returns UUID
 */
export function uuid () {
  return window.crypto?.randomUUID?.() || randomUUID()
}

/**
 * 生成基于随机数的 UUID
 * @description
 * https://en.wikipedia.org/wiki/Universally_unique_identifier
 * Version 4 (random)
 * Variant 1 (10xx2, N = 8..b, 2 bits) are referred to as RFC 4122/DCE 1.1 UUIDs, or "Leach–Salz" UUIDs, after the authors of the original Internet Draft.
 * @returns UUID
 */
function randomUUID () {
  return 'xxxxxxxx-xxxx-4xxx-Nxxx-xxxxxxxxxxxx'.replace(/[xN]/g, character => {
    const r = Math.random() * 16 | 0
    const v = character === 'x' ? r : (r & 0x3 | 0x8)
    return v.toString(16)
  })
}
